import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { RequestsService } from '../home/services/requests.service';
import { RequestHistory } from '../workflow/my-requests/commons/interfaces/my-requests.interface';
import { catchError, from, of } from 'rxjs';

export const DataRequestResolverService: ResolveFn<RequestHistory[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(RequestsService).getRequestUser()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};
